import React, { useMemo } from "react";
import { longDateString } from "../../utils";
import "../../starek.css";

function PartsCardView({
    items,
    selectedRows,
    onSelectedRowsChange,
    filterText,
}) {
    const isPartSelected = (partId) => {
        return selectedRows.some((row) => row.id === partId);
    };

    const handleCheckboxChange = (part) => {
        let newSelectedRows;
        if (isPartSelected(part.id)) {
            newSelectedRows = selectedRows.filter((row) => row.id !== part.id);
        } else {
            newSelectedRows = [...selectedRows, part];
        }
        if (onSelectedRowsChange) {
            onSelectedRowsChange({ selectedRows: newSelectedRows });
        }
    };

    const filteredItems = useMemo(() => {
        const q = filterText?.trim().toLowerCase();
        if (!q) return items;
        return items.filter(
            (item) =>
                item.name?.toLowerCase().includes(q) ||
                item.description?.toLowerCase().includes(q)
        );
    }, [items, filterText]);

    if (filteredItems.length === 0) {
        return (
            <div className="callout callout-info">
                <h5>
                    <i className="icon fa fa-info"></i> No parts found
                </h5>
                <p>Try adjusting your search criteria.</p>
            </div>
        );
    }

    return (
        <div className="row g-3">
            {filteredItems.map((part) => (
                <div key={part.id} className="col-lg-3 col-md-4 col-sm-6">
                    <div
                        className={`card h-100 shadow-sm ${
                            isPartSelected(part.id)
                                ? "border-primary border-2"
                                : ""
                        }`}
                        style={{ cursor: "pointer" }}
                    >
                        <div className="card-header bg-primary text-white">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center flex-grow-1">
                                    <div className="form-check mb-0 me-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={isPartSelected(part.id)}
                                            onChange={() =>
                                                handleCheckboxChange(part)
                                            }
                                            aria-label={`Select ${part.name}`}
                                        />
                                    </div>
                                    <h5
                                        className="card-title mb-0 text-truncate"
                                        title={part.name}
                                    >
                                        {part.name}
                                    </h5>
                                </div>
                                <i className="fa fa-cube fa-lg"></i>
                            </div>
                        </div>
                        <div className="card-body d-flex flex-column">
                            <p
                                className="text-muted mb-3 flex-grow-1"
                                style={{ fontSize: "0.875rem" }}
                            >
                                {part.description || "No description"}
                            </p>
                            <div className="border-top pt-2 mt-auto">
                                <small className="text-muted d-block">
                                    <i className="fas fa-user me-1"></i>
                                    {part.updated_by?.name || "Unknown"}
                                </small>
                                <small className="text-muted d-block mt-1">
                                    <i className="fas fa-clock me-1"></i>
                                    {longDateString(part.updated_at)}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default PartsCardView;
